import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function useSmoothScroll(){
  useEffect(()=>{
    const lenis = new Lenis({ duration:1.05, smoothWheel:true });
    lenis.on('scroll', ScrollTrigger.update);
    const update=(time:number)=>lenis.raf(time*1000);
    gsap.ticker.add(update);
    gsap.ticker.lagSmoothing(0);
    return ()=>{ gsap.ticker.remove(update); lenis.destroy(); };
  },[]);
}
